import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from '../../../data.service';
import { AppData } from '../../../constants/app-data';
import { UrlConstant } from '../../../constants/url-constant';
import { NotificationService } from "../../../services/notification.service";

@Component({
  selector: 'app-test-history',
  templateUrl: './test-history.component.html',
  styleUrls: ['./test-history.component.css']
})
export class TestHistoryComponent implements OnInit {
  eduSys: any = {};
  records: Array<any>; 
  constructor(private router: Router, private routeParams: ActivatedRoute, 
  			public appData: AppData, private dataService: DataService,
  			public notificationService: NotificationService) { }

  ngOnInit(): void {
	this.getIndividualDetail();
  }
	getIndividualDetail(){
		//console.log("=====this.appData.selectedComapnyId :" + this.appData.selectedComapnyId );
		if(this.appData.selectedComapnyId !== null && this.appData.selectedComapnyId !== undefined){
		  	this.prepareIndivDetail(this.appData.selectedComapnyId);
	    } else {
	    	this.appData.user.subscribe(userData=> { 
	  		//this.userId = (userData !== null)? userData.id:""; 
	  		//this.userType = (userData !== null)? userData.individualType:"";
	  		if(userData){
		  		//console.log("indivType:" + userData.individualType + "  loggedInuserid:"+userData.id + "  createdForCompany:"+userData.createdForCompany);
		  	
		  		if(this.appData.userId !== "Admin")
		  			this.prepareIndivDetail(userData.createdForCompany);
		  		else
		  			this.prepareIndivDetail(1);
	  		}
	   	 });
	    }
	}
	prepareIndivDetail(companyId){
		this.dataService.sendPostRequestWithBody(UrlConstant.apiGetEducationalSystem, {"id": companyId}).subscribe((res: any)=>{
		      //console.log(res);
		      this.eduSys = res.data[0];
		    });
			let reqBody = {"createdForCompany": companyId};
			this.dataService.sendPostRequestWithBody(UrlConstant.apiGetIndividual, reqBody).subscribe((res: any)=>{
		      //console.log(res);
		      this.records = res.data;
		    });
	}
	createIndividualMember(){
		this.router.navigate(['/individual-create', {'companyId': this.appData.selectedComapnyId}]);
	}
	updateIndividual(individualId, type){
		if(type === 'record')
			this.router.navigate(['/individual-create', {'id':individualId, 'companyId': this.appData.selectedComapnyId}]);
		else if(type === 'series')
			this.router.navigate(['/test-series-comp-sub-mapping', {'userLoginId':individualId, 'companyId': this.appData.selectedComapnyId}]);
		
	}
	
	deleteIndividual(id){
	  	this.dataService.sendPostRequestWithBody(UrlConstant.apiDeleteIndividual, {"id":id}).subscribe((res: any)=>{
	      //console.log(res);
	      if("SUCCESS" === res.status){
	      	//console.log("Record Deleted Successfully");
	      	this.getIndividualDetail();
	      }
	      //  ##if("SUCCESS" === res.status || "FAIL" === res.status ){
	      	
	    });
	}
	
	
	showTestResult(loginUserId){
		 var body = {'userId': loginUserId};
	  	 //body.userId = this.appData.userId;
	  	this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesPreviousTestResult, body).subscribe((res: any)=>{
	  		if(res.status === 'SUCCESS'){
	  			//this.router.navigate(['/dashboard-test-series',{'p':'x', 'u':loginUserId}]);
	  			//this.router.navigate(['/dashboard-test-series', {}]);
	  			this.router.navigate(['/dashboard-history-detail', {'u':loginUserId}]);
	  		} else {
	  			this.notificationService.error("There is some error. Please try after sometime.");
			}
	  	});
	}
	
	testRecord:any;
	testResultHistoryDetail(loginUserId){
		 this.router.navigate(['/dashboard-history-detail', {'u':loginUserId}]);
	}
}





